/// <reference path="../include.ts" />

namespace project_commons {

	import Logger = alm.debug.Logger;
	import GlobalNavigation = project_commons.GlobalNavigation;
	import WindowWatcher = alm.browser.WindowWatcher;
	import WindowWatcherEvent = alm.browser.WindowWatcherEvent;
	import Boxer = alm.geom.Boxer;
	import Rectangle = alm.geom.Rectangle;
	import ScaleMode = alm.geom.ScaleMode;
	import DeviceInfo = alm.browser.DeviceInfo;
	import Num = alm.util.Num;

	export class Application {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			Logger.setLevelByQuery('log');
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public run():void {
			this.breakPoint = 800;

			// add root class
			this.setupRootClass();

			// setup navigation
			this.globalNavigation = new GlobalNavigation();
			this.globalNavigation.ready();
			//this.globalNavigation.show();

			// carousel / slideshow
			this.setupTopVideo();
			this.setupTopSlideshow();
			this.setupIntroductionSlideshow();
			this.setupUserVoiceCarousel();

			// logo grid
			//this.setupLogoContainer();

			// modal movie
			(<any>jQuery('#top-movie-modal-open-button')).modalVideo();

			// letter spacing
			this.setupLetterSpacing();

			// retina image
			this.setupRetinaImage();

			// start
			WindowWatcher.addEventListener(WindowWatcherEvent.RESIZE, this.windowWatcherResizeHandler);
			WindowWatcher.start();
			this.resize();

			// for android
			if (document.location.href.indexOf('#') == -1) {
				setTimeout(():void => {
					jQuery('html, body').scrollTop(0);
				}, 100);
			}
		}

		private setupRootClass():void {
			const html = jQuery('html');

			// detecting language
			const directories = window.location.href.split('/');
			const lang = directories[directories.length - 2];
			html.addClass('lang-' + lang);
			trace('[Application] lang :', lang);

			if (lang == 'ja') {
				html.addClass('lang-not-en');
			}
			if (lang == 'en') {
				html.addClass('lang-not-ja');
			}

			// detecting env
			const browser = DeviceInfo.getIsIE() ? 'ie' : 'not-ie';
			html.addClass('browser-' + browser);
			trace('[Application] browser :', browser);
		}

		private setupRetinaImage():void {
			if (window.devicePixelRatio >= 2) {
				jQuery('img.retina').each((index:number, element:HTMLElement):void => {
					const target = jQuery(element);
					const imageUrl = target.attr('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
					target.attr('srcset', imageUrl + " 2x");
				});
			}
		}

		private setupLetterSpacing():void {
			jQuery('p,a,h2,td,th,.section-title,section-subtitle,.title,.text').each((index:number, element:HTMLElement):void => {
				let html = element.innerHTML;
				html = html.replace(/。/g, '<span class="char-period">。</span>');
				html = html.replace(/、/g, '<span class="char-comma">、</span>');
				element.innerHTML = html;
			});
		}

		private setupMobileDeviceTouchEffect():void {
			jQuery('a,button,.hover-effect').each((index:number, element:HTMLElement):void => {
				element.addEventListener('touchstart', ():void => {});
			});
		}

		private setupTopVideo():void {
			this.topMovieVideo = jQuery('#top-movie-video');
			this.topMovieLink = jQuery('#top-movie-link');

			this.topMovieArrowDesktop = jQuery('#top-movie-arrow-desktop');
			this.topMovieArrowImageDesktop = this.topMovieArrowDesktop.find('.icon');
		}

		private setupTopSlideshow():void {
			const slideshow = jQuery('#top-slideshow');
			this.topSlideshowSlide = slideshow.find('.image');

			(<any>slideshow).slick({
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				dots: false,
				arrows: false,
				touchMove: false,
				swipe: false
			});
		}

		private setupIntroductionSlideshow():void {
			const slideshow = jQuery('#product-screen-slideshow');

			(<any>slideshow).slick({
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				dots: false,
				arrows: false,
				touchMove: false,
				swipe: false
			});
		}

		private setupUserVoiceCarousel():void {
			const slideshow = jQuery('#uservoice-slideshow');

			const controller = jQuery('#uservoice-controller');
			const nextButton = controller.find('.slick-next-button');
			const prevButton = controller.find('.slick-prev-button');
			const dotIndicator = controller.find('.slick-dots');

			(<any>slideshow).slick({
				rows: 5,
				autoplay: false,
				dots: true,
				dotsClass: 'slick-dots',
				appendDots: dotIndicator,
				prevArrow: prevButton,
				nextArrow: nextButton,
				infinite: false,

				responsive: [{
					breakpoint: this.breakPoint,
					settings: { rows: 3 }
				}]
			});

			nextButton.hover(():void => {
				nextButton.animate({ opacity: 0.5 }, 200);
			}, ():void => {
				nextButton.animate({ opacity: 1 }, 600);
			});

			prevButton.hover(():void => {
				prevButton.animate({ opacity: 0.5 }, 200);
			}, ():void => {
				prevButton.animate({ opacity: 1 }, 600);
			});
		}

		private setupLogoContainer():void {
			const grids = jQuery('.logo-container');

			const gridCount = grids.length;
			for (let i = 0; i < gridCount; ++i) {
				const grid = jQuery(grids.get(0));

				const defaultCells = grid.find('.logo');
				const defaultCellCount = defaultCells.length;
				const emptyCells:JQuery[] = [];
				for (let j = 0; j < defaultCellCount; ++j) {
					const cell = jQuery('<li>');
					cell.addClass('logo empty');
					emptyCells.push(cell);
				}

				grid.append(emptyCells);
			}
		}





		private resizeTopVideo():void {
			const windowWidth = WindowWatcher.getWindowWidth();
			const windowHeight = WindowWatcher.getWindowHeight();

			const contentAspectRatio = 16 / 9;
			const contentMaxWidth = Math.min(windowWidth, 1920);
			const contentMaxHeight = windowHeight;

			const resizedRect = Boxer.resize(new Rectangle(0, 0, contentAspectRatio, 1), new Rectangle(0, 0, contentMaxWidth, contentMaxHeight), ScaleMode.ShowAll);
			const resizedWidth = resizedRect.width;
			this.topMovieVideo.css('max-width', resizedWidth);
			this.topMovieLink.css('max-width', resizedWidth);

			if (resizedWidth < windowWidth) {
				this.topMovieLink.removeClass('full-width');
			} else {
				this.topMovieLink.addClass('full-width');
			}

			this.topMovieArrowDesktop.css('height', resizedRect.height);
			this.topMovieArrowImageDesktop.css('width', Num.map(resizedWidth, 800, 1200, 40, 50));
		}

		private resizeTopSlideshow():void {
			const windowWidth = WindowWatcher.getWindowWidth();
			const windowHeight = WindowWatcher.getWindowHeight();

			this.topSlideshowSlide.css({ width:windowWidth, height:windowHeight });
		}

		private resize():void {
			this.resizeTopVideo();
			this.resizeTopSlideshow();
		}

		private windowWatcherResizeHandler = (event:WindowWatcher):void => {
			this.resize();
		};





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		private breakPoint:number;

		private globalNavigation:GlobalNavigation;

		private topMovieVideo:JQuery;
		private topMovieLink:JQuery;
		private topMovieArrowDesktop:JQuery;
		private topMovieArrowImageDesktop:JQuery;

		private topSlideshowSlide:JQuery;
	}
}
